import axios from 'axios';

export function restartPluginWorker(token) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/admin/plugin-worker/restart`,
        {},
        {
            headers: {
                Authorization: `${token}`,
            },
        }
    );
}
